// frontend/src/services/api.js
import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Intercepteur pour ajouter le token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('❌ Erreur API:', error.response.status, error.response.data);
      
      if (error.response.status === 401) {
        console.log('🔴 401 sur:', error.config?.url);
        const userType = localStorage.getItem('userType');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userType');
        if (userType === 'client') {
          window.location.href = '/login/client';
        } else if (userType === 'admin') {
          window.location.href = '/login/admin';
        } else {
          window.location.href = '/login/partner';
        }
      }
    } else if (error.request) {
      console.error('❌ Pas de réponse du serveur:', error.request);
      console.error('❌ Vérifie que le backend tourne sur http://localhost:5000');
    } else {
      console.error('❌ Erreur de requête:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default API;